import React from "react";
import {PrimaryCollapsibleSection} from "../../../../../elements/collapsableSection/primary/PrimaryCollapsibleSection";
import {CardField, SignPosition} from "./components/CardField";
import {ReturnedFuelCostChatEventDTO} from "../../../../../../api/generated";

interface FuelCostChatEventCardProps {
    returnedFuelCostChatEvent: ReturnedFuelCostChatEventDTO
}

export const FuelCostChatEventCard: React.FC<FuelCostChatEventCardProps> = ({
    returnedFuelCostChatEvent
}) => {

    const getMonthlyFuelCost = (cost: number | undefined): string | number => {
        if (!cost || cost === 0) {
            return "-"
        }
        return cost.toFixed(2)
    }

    return <PrimaryCollapsibleSection title={"Fuel Cost Calculation"}>
        <CardField
            title="Stock Vehicle VRM"
            value={returnedFuelCostChatEvent.stock_vehicle_vrm}
        />
        <CardField
            title="Fuel Type"
            value={returnedFuelCostChatEvent.fuel_cost_stock_vehicle_fuel_type}
        />
        <CardField
            title="MPG"
            value={returnedFuelCostChatEvent.fuel_cost_stock_vehicle_mpg}
        />
        <CardField
            title="Annual Mileage"
            value={returnedFuelCostChatEvent.fuel_cost_annual_mileage}
        />
        <CardField
            title="Stock Vehicle Monthly Cost"
            value={getMonthlyFuelCost(returnedFuelCostChatEvent.fuel_cost_for_stock_vehicle)}
            sign={"£"}
            signPosition={SignPosition.START}
        />
        
        {returnedFuelCostChatEvent.user_vehicle_vrm && (
            <>
                <CardField
                    title="User Vehicle VRM"
                    value={returnedFuelCostChatEvent.user_vehicle_vrm}
                />
                <CardField
                    title="User Vehicle Fuel Type"
                    value={returnedFuelCostChatEvent.fuel_cost_user_vehicle_fuel_type}
                />
                <CardField
                    title="User Vehicle MPG"
                    value={returnedFuelCostChatEvent.fuel_cost_user_vehicle_mpg}
                />
                <CardField
                    title="User Vehicle Monthly Cost"
                    value={getMonthlyFuelCost(returnedFuelCostChatEvent.fuel_cost_for_user_vehicle)}
                    sign={"£"}
                    signPosition={SignPosition.START}
                />
            </>
        )}
    </PrimaryCollapsibleSection>
}
